import { Pipe, PipeTransform } from 'angular-ts-decorators';
import { escapeRegExp } from 'lodash';

/**
 * This filter can be used to highlight filtered words in a text.
 * @param {string} input user input
 * @param {string} phrase string to be highlighted
 * @return {string} returns highlighted string
 */
@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  constructor(
    private $sce: ng.ISCEService,
    private $sanitize: ng.sanitize.ISanitizeService,
  ) {
    'ngInject';
  }

  public transform(input: string, phrase: string): string {
    let text: string;

    if (angular.isString(input)) {
      text = this.$sanitize(input);
    } else {
      return input;
    }

    if (angular.isString(phrase) && phrase !== '') {
      phrase = escapeRegExp(phrase);

      text = text.replace(
        new RegExp('(' + phrase + ')', 'gi'),
        '<span class="highlighted">$1</span>',
      );
    }

    return this.$sce.trustAsHtml(text);
  }
}
